import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { I18nContext } from '../../I18n'

import styles from './InfoBlock.module.css'

InfoBlock.propTypes = {
  start: PropTypes.number
}

export default function InfoBlock({ start }) {
  const I18n = useContext(I18nContext)

  return (
    <div className={styles.a}>
      <div className={styles.container}>
        <div className={styles.root}>
         {/* Блок для дополнительной информации */}
          <div className={styles.title}>
            <h3 className={styles.text}>
              {I18n.t('pages.index.infoblock.title')}
            </h3>

          </div>

          <div className={styles.action}>
            <span className={styles.button}>
              <a className={styles.a} href='https://lunn.ru/news/16586'>
                {I18n.t('pages.index.infoblock.more')}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>

  )
}
